import React, { useState, useEffect, useCallback } from "react";
import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { createOrder, getCurrencies, getSlabs } from "../services/order_services";
import { toast } from "react-toastify";
import { getCoutries } from "../services/public_service";




const topUpProducts = [
  { id: 1, amount: 100, bonus: 0 },
  { id: 2, amount: 200, bonus: 0},
  { id: 3, amount: 500, bonus: 0 },
  { id: 4, amount: 1000, bonus: 0 },
];


const getOperatorId = (phoneNumber) => {
  const cleanedNumber = phoneNumber.replace(/\D/g, '');
  const prefix = cleanedNumber.substring(0, 2);
  
  if (['78', '73'].includes(prefix)) return 2;
  if (['76', '77'].includes(prefix)) return 4;
  if (['74'].includes(prefix)) return 1;
  if (['79', '72'].includes(prefix)) return 3;
  if (['70', '71'].includes(prefix)) return 5;
  
  return 2;
};

export default function StripePaymentModal({ open, onClose, onSuccess }) {
  const queryClient = useQueryClient();
  const [step, setStep] = useState(1);
  const [amount, setAmount] = useState("");
  const [phone, setPhone] = useState("");
   const [selectedCountry, setSelectedCountry] = useState(null);
  const [cardName, setCardName] = useState("");
  const [cardNumberComplete, setCardNumberComplete] = useState(false);
  const [cardExpiryComplete, setCardExpiryComplete] = useState(false);
  const [cardCvcComplete, setCardCvcComplete] = useState(false);
  const [errors, setErrors] = useState({});
  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [requiresAction, setRequiresAction] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [activeTab, setActiveTab] = useState("topup");
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [exchangeRate, setExchangeRate] = useState(null);
  const [slabPercentage, setSlabPercentage] = useState(0);
  const [loadingData, setLoadingData] = useState(false);
  
  const stripe = useStripe();
  const elements = useElements();

  const { data: countriesData, isLoading: loadingCountries } = useQuery({
    queryKey: ['countries'],
    queryFn: getCoutries,
    enabled: open, 
    select: (data) => {
      if ( data.data) {
        return data.data.map(country => ({
          id: country.id,
          code: country.countryCode,
          name: country.countryName,
        }));
      }
      return [];
    },
  });
 console.log(countriesData, "this si country data")
  const calculateUsdAmount = useCallback((afnAmount) => {
    if (!exchangeRate || !afnAmount) return 0;
    
    const baseAmount = parseFloat(afnAmount) * exchangeRate;
    const feeAmount = baseAmount * (slabPercentage / 100);
    const totalAmount = baseAmount + feeAmount;
    
    return totalAmount.toFixed(2);
  }, [exchangeRate, slabPercentage]);

  const calculateFeeAmount = useCallback((afnAmount) => {
    if (!exchangeRate || !afnAmount) return 0;
    
    const baseAmount = parseFloat(afnAmount) * exchangeRate;
    const feeAmount = baseAmount * (slabPercentage / 100);
    
    return feeAmount.toFixed(2);
  }, [exchangeRate, slabPercentage]);

  const calculateBaseAmount = useCallback((afnAmount) => {
    if (!exchangeRate || !afnAmount) return 0;
    
    const baseAmount = parseFloat(afnAmount) * exchangeRate;
    return baseAmount.toFixed(2);
  }, [exchangeRate]);

  useEffect(() => {
    const fetchRateAndSlab = async () => {
      if (!selectedCountry) return;
      
      setLoadingData(true);
      try {
        const rateData = await getCurrencies();
        console.log(rateData, "this is rateData"); 

        if (rateData && rateData.success && rateData.data && rateData.data.length > 0) {
          const usdToAfnRate = parseFloat(rateData.data[0].target_amount);
          console.log(usdToAfnRate, "this is usd rateData"); 
          setExchangeRate(1 / usdToAfnRate);
        } else {
          console.warn("getCurrencies returned no valid data");
          setExchangeRate(0.012); 
        }

        const slabData = await getSlabs();
        console.log(slabData, "this is slab data");
        
        if (slabData && slabData.success && slabData.data && slabData.data.length > 0) {
          const countrySlab = slabData.data.find(slab => slab.countryId === selectedCountry.id);
          if (countrySlab) {
            setSlabPercentage(parseFloat(countrySlab.percentage));
          } else {
            setSlabPercentage(0);
          }
        } else {
          setSlabPercentage(0);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setExchangeRate(0.012);
        setSlabPercentage(0);
      } finally {
        setLoadingData(false);
      }
    };
    
    if (selectedCountry) {
      fetchRateAndSlab();
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open]);


  useEffect(() => {
    if (countriesData && countriesData.length > 0 && !selectedCountry) {
      setSelectedCountry(countriesData[0]);
    }
  }, [countriesData, selectedCountry]);

  const resetForm = () => {
    setStep(1);
    setAmount("");
    setPhone("");
    setSelectedCountry(countriesData && countriesData.length > 0 ? countriesData[0] : null);
    setCardName("");
    setErrors({});
    setIsProcessing(false);
    setPaymentIntent(null);
    setRequiresAction(false);
    setClientSecret("");
    setCardNumberComplete(false);
    setCardExpiryComplete(false);
    setCardCvcComplete(false);
    setActiveTab("topup");
    setShowCountryDropdown(false);
    setExchangeRate(null);
    setSlabPercentage(0);
  };
  const validateStep1 = () => {
    const newErrors = {};
    
    if (!phone) {
      newErrors.phone = "Please enter a mobile number";
    } else if (isNaN(phone.replace(/\s/g, ''))) {
      newErrors.phone = "Mobile number must contain only numbers";
    } else if (phone.replace(/\s/g, '').length < 9) {
      newErrors.phone = "Please enter a valid mobile number";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep2 = () => {
    const newErrors = {};
    
    if (activeTab === "topup" && !amount) {
      newErrors.amount = "Please enter an amount";
    } else if (activeTab === "topup" && isNaN(amount)) {
      newErrors.amount = "Amount must be a number";
    } else if (activeTab === "topup" && parseFloat(amount) <= 0) {
      newErrors.amount = "Amount must be greater than 0";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateStep4 = () => {
    const newErrors = {};

    if (!cardName) {
      newErrors.cardName = "Please enter the cardholder name";
    }

    if (!cardNumberComplete) {
      newErrors.cardNumber = "Please enter a valid card number";
    }

    if (!cardExpiryComplete) {
      newErrors.cardExpiry = "Please enter a valid expiry date";
    }

    if (!cardCvcComplete) {
      newErrors.cardCvc = "Please enter a valid CVC";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (step === 1 && validateStep1()) {
      setStep(2);
    } else if (step === 2 && validateStep2()) {
      setStep(3);
    } else if (step === 3) {
      setStep(4);
    } else if (step === 4 && validateStep4()) {
      processPayment();
    }
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  const { mutate: createOrderMutation, isPending } = useMutation({
    mutationFn: (payload) => createOrderC(payload),
    onSuccess: (data) => {
      if (data.status === "requires_action" && data.nextAction) {
        setRequiresAction(true);
        setClientSecret(data.nextAction.clientSecret);
        setPaymentIntent({ id: data.nextAction.paymentIntentId });
      } else if (data.status === "success" || data.status === "inprocess") {
        setStep(6);
        toast.success("Payment processed successfully!");
        onSuccess();
        queryClient.invalidateQueries({ queryKey: ["orders"], exact: false });
      } else {
        setStep(6);
        toast.error(`Payment status: ${data.status}`);
      }
    },
    onError: (error) => {
      setStep(6);
      const message = error?.response?.data?.error || "Payment failed. Please try again.";
      toast.error(message);
      setErrors({ submit: message });
      setIsProcessing(false);
    },
  });

  const handle3DSecureAuthentication = async () => {
    if (!stripe || !clientSecret) return;

    try {
      const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret);
      
      if (error) {
        throw new Error(error.message);
      }
      
      if (paymentIntent.status === "succeeded") {
        setStep(6);
        toast.success("Payment processed successfully!");
        onSuccess();
        queryClient.invalidateQueries({ queryKey: ["orders"], exact: false });
      }
    } catch (error) {
      setStep(6);
      toast.error(error.message);
      setErrors({ submit: error.message });
      setIsProcessing(false);
    }
  };

  const processPayment = useCallback(async () => {
    setIsProcessing(true);

    try {
      if (!stripe || !elements) {
        throw new Error("Stripe has not loaded yet.");
      }

      const cardNumberElement = elements.getElement(CardNumberElement);
      
      if (!cardNumberElement) {
        throw new Error("Card element not found.");
      }

      const { paymentMethod, error: paymentMethodError } = await stripe.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          name: cardName,
        },
      });

      if (paymentMethodError) {
        throw new Error(paymentMethodError.message);
      }
      setStep(5);
      const operatorId = getOperatorId(phone);
      const cleanedPhone = phone.replace(/\s/g, '');
      const usdAmount = calculateUsdAmount(amount);

      const payload = {
        receiver: cleanedPhone,
        amount: parseFloat(amount),
        source: "stripe_card",
        operator: operatorId.toString(),
        currency: "AFN",
        countryId: selectedCountry.id,
        productId: 2,
        cardCurrency: "USD",
        cardAmount: usdAmount,
        paymentMethodId: paymentMethod.id,
        confirmNow: true,
      };

      createOrderMutation(payload);
    } catch (error) {
      setStep(6);
      toast.error(error.message);
      setErrors({ submit: error.message });
      setIsProcessing(false);
    }
  }, [stripe, elements, phone, amount, cardName, selectedCountry, calculateUsdAmount, createOrderMutation]);

  const selectProduct = (productAmount) => {
    setAmount(productAmount.toString());
  };

 

  return (
    <div className="inset-0  bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-[600px] overflow-hidden">
     
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800">
            {step === 1 && "Enter Mobile Number"}
            {step === 2 && "Select Top-up or Product"}
            {step === 3 && "Review Order"}
            {step === 4 && "Payment Details"}
            {step === 5 && "Processing Payment"}
            {step === 6 && "Payment Result"}
          </h2>
          {/* <button 
            onClick={onClose} 
            disabled={isProcessing}
            className="text-gray-500 hover:text-gray-700 disabled:opacity-50"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button> */}
        </div>
        

        <div className="p-6">

         {step === 1 && (
            <div>
              <p className="text-gray-600 mb-6">Enter the mobile number you want to top up</p>
       
              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                <div className="relative flex focus-within:ring-2  focus-within:ring-primary focus-within:border-primary rounded-md border border-gray-300">
                  <div className="relative">
                    <button 
                      type="button"
                      className="flex items-center justify-between w-28 px-3 py-3 bg-white border border-r-0 border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-primary "
                      onClick={() => setShowCountryDropdown(!showCountryDropdown)}
                      disabled={loadingCountries}
                    >
                      {loadingCountries ? (
                        <svg className="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      ) : (
                        <>
                          {/* <span className="mr-2">{selectedCountry?.flag || '🏳️'}</span> */}
                          <span>{selectedCountry?.code || '+...'}</span>
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </>
                      )}
                    </button>
                    
                    {showCountryDropdown && !loadingCountries && (
                      <div className="absolute z-10 mt-1 w-48 bg-white shadow-lg rounded-md py-1 max-h-60 overflow-auto">
                        {countriesData && countriesData.map(country => (
                          <button
                            key={country.code}
                            className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full"
                            onClick={() => {
                              setSelectedCountry(country);
                              setShowCountryDropdown(false);
                            }}
                          >
                            <span className="mr-2">{country.flag}</span>
                            <span className="mr-2">{country.name}</span>
                            {/* <span className="text-gray-500 ml-auto">{country.dialCode}</span> */}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                    placeholder="e.g. 787710623"
                    className="flex-1 min-w-0 block w-full px-3 py-3 rounded-r-md border border-gray-300  focus:outline-none focus:ring-2 focus:ring-primary "
                    disabled={loadingCountries}
                  />
                </div>
                {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
              </div>
            </div>
          )}
          
      
          {step === 2 && (
            <div>
              <p className="text-gray-600 mb-6">Select top-up amount or product</p>
              
          
              <div className="mb-5">
                <div className="flex bg-gray-100 rounded-lg p-1">
                  <button
                    className={`flex-1 py-2 px-4 rounded-md text-sm font-medium ${activeTab === "topup" ? "bg-primary text-white shadow" : "text-gray-600"}`}
                    onClick={() => setActiveTab("topup")}
                  >
                    Top-up
                  </button>
                  <button
                    className={`flex-1 py-2 px-4 rounded-md text-sm font-medium ${activeTab === "product" ? "bg-white shadow" : "text-gray-600"}`}
                    onClick={() => setActiveTab("product")}
                  >
                    Product
                  </button>
                </div>
              </div>
              
              {activeTab === "topup" ? (
                <>
               
                  <div className="mb-5">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Amount (AFN)</label>
                    <input
                      type="number"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      className="block w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                      placeholder="Enter amount"
                    />
                    {errors.amount && <p className="mt-1 text-sm text-red-600">{errors.amount}</p>}
                  </div>
                  
             
                  <div className="mb-5">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Quick Top-up</label>
                    <div className="grid grid-cols-2 gap-3">
                      {topUpProducts.map(product => (
                        <button
                          key={product.id}
                          className={`p-3 border rounded-md text-center ${amount === product.amount.toString() ? 'border-primary/90 bg-red-50' : 'border-gray-300 hover:border-primary/90'}`}
                          onClick={() => selectProduct(product.amount)}
                        >
                          <div className="font-medium">{product.amount} AFN</div>
                          {product.bonus > 0 && (
                            <div className="text-xs text-green-600">+{product.bonus} bonus</div>
                          )}
                        </button>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <div className="mb-5 p-10 text-center bg-gray-50 rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto text-gray-400 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <p className="text-gray-500">Product top-up coming soon</p>
                </div>
              )}
            </div>
          )}
          
          {/* Step 3: Review Order */}
          {step === 3 && (
            <div>
              <p className="text-gray-600 mb-6">Review your order details</p>
              
              <div className="border border-gray-200 rounded-md p-4 mb-5">
                <h3 className="text-sm font-medium text-gray-700 mb-3">Order Summary:</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Recipient:</span>
                    <span className="text-gray-800">{selectedCountry.dialCode} {phone}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Type:</span>
                    <span className="text-gray-800">{activeTab === "topup" ? "Top-up" : "Product"}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Amount:</span>
                    <span className="text-gray-800">{amount} AFN</span>
                  </div>
                  {loadingData ? (
                    <div className="flex justify-center py-2">
                      <svg className="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </div>
                  ) : (
                    <>
                      <div className="flex justify-between">
                        <span className="text-gray-500">Base Amount:</span>
                        <span className="text-gray-800">${calculateBaseAmount(amount)} USD</span>
                      </div>
                      {slabPercentage > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-500">Fee ({slabPercentage}%):</span>
                          <span className="text-gray-800">${calculateFeeAmount(amount)} USD</span>
                        </div>
                      )}
                      <div className="flex justify-between pt-2 border-t border-gray-100">
                        <span className="text-gray-700 font-medium">Total:</span>
                        <span className="text-primary font-medium">${calculateUsdAmount(amount)} USD</span>
                      </div>
                    </>
                  )}
                </div>
              </div>
              
              <div className="p-4 bg-red-50 rounded-md">
                <p className="text-sm text-gray-600">
                  Exchange rate: 1 AFN ≈ {exchangeRate ? exchangeRate.toFixed(4) : '0.0120'} USD
                  {slabPercentage > 0 && ` + ${slabPercentage}% fee`}
                </p>
              </div>
            </div>
          )}
          
    
          {step === 4 && (
            <div>
              <p className="text-gray-600 mb-6">Enter your card details for payment</p>
              
              
              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 mb-1">Cardholder Name</label>
                <input
                  type="text"
                  value={cardName}
                  onChange={(e) => setCardName(e.target.value)}
                  className="block w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                  placeholder="Name on card"
                />
                {errors.cardName && <p className="mt-1 text-sm text-red-600">{errors.cardName}</p>}
              </div>
              
       
              <div className="space-y-4">
      
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Card Number</label>
                  <div className="p-3 border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-primary focus-within:border-primary">
                    <CardNumberElement
                      options={{
                        style: {
                          base: {
                            fontSize: '16px',
                            color: '#374151',
                            '::placeholder': {
                              color: '#9CA3AF',
                            },
                          },
                        },
                      }}
                      onChange={(e) => {
                        setCardNumberComplete(e.complete);
                        if (e.error) {
                          setErrors({ ...errors, cardNumber: e.error.message });
                        } else {
                          const newErrors = { ...errors };
                          delete newErrors.cardNumber;
                          setErrors(newErrors);
                        }
                      }}
                    />
                  </div>
                  {errors.cardNumber && <p className="mt-1 text-sm text-red-600">{errors.cardNumber}</p>}
                </div>
                
                <div className="grid grid-cols-2 gap-4">
              
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Expiry Date</label>
                    <div className="p-3 border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-primary focus-within:border-primary">
                      <CardExpiryElement
                        options={{
                          style: {
                            base: {
                              fontSize: '16px',
                              color: '#374151',
                              '::placeholder': {
                                color: '#9CA3AF',
                              },
                            },
                          },
                        }}
                        onChange={(e) => {
                          setCardExpiryComplete(e.complete);
                          if (e.error) {
                            setErrors({ ...errors, cardExpiry: e.error.message });
                          } else {
                            const newErrors = { ...errors };
                            delete newErrors.cardExpiry;
                            setErrors(newErrors);
                          }
                        }}
                      />
                    </div>
                    {errors.cardExpiry && <p className="mt-1 text-sm text-red-600">{errors.cardExpiry}</p>}
                  </div>
                  
               
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">CVC</label>
                    <div className="p-3 border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-primary focus-within:border-primary">
                      <CardCvcElement
                        options={{
                          style: {
                            base: {
                              fontSize: '16px',
                              color: '#374151',
                              '::placeholder': {
                                color: '#9CA3AF',
                              },
                            },
                          },
                        }}
                        onChange={(e) => {
                          setCardCvcComplete(e.complete);
                          if (e.error) {
                            setErrors({ ...errors, cardCvc: e.error.message });
                          } else {
                            const newErrors = { ...errors };
                            delete newErrors.cardCvc;
                            setErrors(newErrors);
                          }
                        }}
                      />
                    </div>
                    {errors.cardCvc && <p className="mt-1 text-sm text-red-600">{errors.cardCvc}</p>}
                  </div>
                </div>
              </div>
              
        
              <div className="p-4 bg-red-50 rounded-md mt-5">
                <p className="text-sm text-gray-600">
                  You will be charged: <strong>${calculateUsdAmount(amount)} USD</strong>
                  {slabPercentage > 0 && ` (includes ${slabPercentage}% fee)`}
                </p>
              </div>
            </div>
          )}
          

          {step === 5 && (
            <div className="flex flex-col items-center justify-center py-10">
              <svg className="animate-spin h-12 w-12 text-blue-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <h3 className="text-lg font-medium text-gray-800 mb-2">Processing Payment</h3>
              <p className="text-gray-600 text-center">Please wait while we process your payment. Do not refresh or close this page.</p>
            </div>
          )}
    
          {step === 6 && (
            <div>
              {errors.submit ? (
                <div className="p-4 bg-red-50 rounded-md mb-5">
                  <div className="flex">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-red-800">Error</h3>
                      <p className="text-sm text-red-600 mt-1">{errors.submit}</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="p-4 bg-green-50 rounded-md mb-5">
                  <div className="flex">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <div className="ml-3">
                      <h3 className="text-sm font-medium text-green-800">Success</h3>
                      <p className="text-sm text-green-600 mt-1">Payment processed successfully!</p>
                    </div>
                  </div>
                </div>
              )}
              
          
              <div className="border border-gray-200 rounded-md p-4">
                <h3 className="text-sm font-medium text-gray-700 mb-3">Transaction Details:</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Recipient:</span>
                    <span className="text-gray-800">{selectedCountry.dialCode} {phone}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Amount:</span>
                    <span className="text-gray-800">{amount} AFN</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Base Amount:</span>
                    <span className="text-gray-800">${calculateBaseAmount(amount)} USD</span>
                  </div>
                  {slabPercentage > 0 && (
                    <div className="flex justify-between">
                      <span className="text-gray-500">Fee ({slabPercentage}%):</span>
                      <span className="text-gray-800">${calculateFeeAmount(amount)} USD</span>
                    </div>
                  )}
                  <div className="flex justify-between">
                    <span className="text-gray-500">Total Charged:</span>
                    <span className="text-gray-800">${calculateUsdAmount(amount)} USD</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Date:</span>
                    <span className="text-gray-800">{new Date().toLocaleDateString()}</span>
                  </div>
                  {paymentIntent && (
                    <div className="flex justify-between">
                      <span className="text-gray-500">Payment ID:</span>
                      <span className="text-gray-800 text-xs truncate max-w-[120px]">{paymentIntent.id}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        

        <div className="flex justify-between  p-6 border-t">
          {step === 1 && (
            <>
              {/* <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2"
              >
                Cancel
              </button> */}
              <button
                onClick={handleNext}
                disabled={!phone}
                className="px-4 py-2 justify-center flex flex-auto text-sm font-medium text-white bg-primary border border-transparent rounded-md shadow-sm hover:bg-[#a50303]  focus:outline-none focus:ring-2  focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Continue
              </button>
            </>
          )}
          
          {step === 2 && (
            <>
              <button
                onClick={handleBack}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2  focus:ring-offset-2"
              >
                Back
              </button>
              <button
                onClick={handleNext}
                disabled={activeTab === "topup" && !amount}
                className="px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Continue
              </button>
            </>
          )}
          
          {step === 3 && (
            <>
              <button
                onClick={handleBack}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Back
              </button>
              <button
                onClick={handleNext}
                className="px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Continue to Payment
              </button>
            </>
          )}
          
          {step === 4 && (
            <>
              <button
                onClick={handleBack}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Back
              </button>
              <button
                onClick={handleNext}
                disabled={isProcessing || !cardNumberComplete || !cardExpiryComplete || !cardCvcComplete}
                className="flex items-center px-4 py-2 text-sm font-medium text-white bg-primary border border-transparent rounded-md shadow-sm hover:bg-[#960404] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
                Pay Now
              </button>
            </>
          )}
          
          {step === 6 && (
            <button
              onClick={() => {
                resetForm();
                onClose();
              }}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Done
            </button>
          )}
        </div>
      </div>
    </div>
  );
}